exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-name-selector {\n  display: block;\n}\n\nupd-dialog.name-selector {\n  --upd-dialog-backdrop: rgba(0, 0, 0, 0.4);\n}\n", ""]);

